type EventHandler = (...args: any[]) => void;

class EventEmitter {
  private events: Record<string, EventHandler[]> = {};

  on(event: string, handler: EventHandler): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(handler);
  }

  off(event: string, handler: EventHandler): void {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(h => h !== handler);
  }

  emit(event: string, ...args: any[]): void {
    if (!this.events[event]) return;
    this.events[event].forEach(handler => {
      try {
        handler(...args);
      } catch (error) {
        console.error(`Error in event listener for ${event}:`, error);
      }
    });
  }
}

// Create a named instance before exporting
const eventEmitter = new EventEmitter();

export const EVENTS = {
  HAZARD_ADDED: 'HAZARD_ADDED',
  HAZARD_DELETED: 'hazard_deleted',
  HAZARD_UPDATED: 'HAZARD_UPDATED', // Add this new event
  HAZARD_TAGGED: 'HAZARD_TAGGED', // Hazard tags updated
  HAZARDS_UPDATED: 'HAZARDS_UPDATED', // Bulk hazards update event
  COMMUNITY_HAZARDS_UPDATED: 'COMMUNITY_HAZARDS_UPDATED', // Community hazards updated
  COMMENT_ADDED: 'comment_added',
  COMMENT_UPDATED: 'comment_updated',
  COMMENT_DELETED: 'comment_deleted',
  COMMENT_SYNCED: 'comment_synced',
  COMMENTS_SYNCED: 'comments_synced',
  REACTION_ADDED: 'REACTION_ADDED',
  REACTION_DELETED: 'REACTION_DELETED',
  REACTIONS_SYNCED: 'REACTIONS_SYNCED',
  POLLING_ERROR: 'POLLING_ERROR', // Polling error event
  NOTIFICATION_RECEIVED: 'NOTIFICATION_RECEIVED',
  NOTIFICATIONS_CLEARED: 'NOTIFICATIONS_CLEARED',
  NOTIFICATION_MARKED_READ: 'NOTIFICATION_MARKED_READ',
  PROFILE_UPDATED: 'PROFILE_UPDATED', // User updated their display name / avatar
  CACHE_CHANGED: 'CACHE_CHANGED' // Per-user hazard cache was written; readers should re-read
};

export default eventEmitter;